export default __webpack_public_path__ + "static/media/12-marina-gallo-ophiuchus-jewels-paine-chile-travel-diary.f4c24a58.jpg";